module.exports = __webpack_public_path__ + "static/img/0-1 home.ca292197.png";